import { getDateTime } from "../../services/CheckMeProBlePackages";
import { decodeString } from "../../services/EshBleUtils";
import { ECGInnerItem    } from "./ECGInnerItem";
import { CheckMeProUser } from "./User";
export interface PressureItem{

    date: Date
    pr : number
    dia:number
    sys:number
    user:CheckMeProUser
   
   
}
const PACKAGESIZE =11;
export function parsePressureItem (bytes: number[] ,checkMeProUser : CheckMeProUser ) : PressureItem[]{
    
    let start = 0
 
    const returnList:  PressureItem[] = new Array();
    for (let k = 0; k < bytes.length -8; k++) {
        if ( start +PACKAGESIZE >= bytes.length  )
            break;
        const user = {} as PressureItem
        returnList.push(user)

        start = k * PACKAGESIZE
         user.date = getDateTime(bytes,start)
         user.sys =  (bytes[start + 7] & 0xff) + ((bytes[start + 8] & 0xff) << 8); 
         user.dia = bytes[start + 9]
         user.pr = bytes[start + 10]
        user.user = checkMeProUser
      

    }

    return returnList;

}
